import React, { useEffect, useRef, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BaseUrl from "../../base-api";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { isloading } from "../redux/reducer/LoadingReducer";
import { useDispatch } from "react-redux";
import AxiosInstance from "../Utility/AxiosInstance";
import { getPageNumbers } from "../Utility/pagination";
import { handleAxiosError } from "../Utility/handleAxiosError";
const Images = () => {
  const [images, setImages] = useState([]);
  const [locations, setLocations] = useState([]);
  const [newImage, setNewImage] = useState({ location: "", file: null });
  const fileInputRef = useRef(null);
  const token = sessionStorage.getItem("userToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [viewImages, setViewImages] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const fetchData = async (pageNumber = currentPage) => {
    const backendPage = pageNumber - 1;
    setSearchQuery("");
    setCurrentPage(1);
    const token = sessionStorage.getItem("userToken");
    if (!token) return navigate("/login");
    dispatch(isloading());
    try {
      const resLocation = await AxiosInstance.get(
        `${BaseUrl}/api/master/imageType`
      );

      if (resLocation.data.status === 200) {
        const locationTypes = resLocation.data.data.map((item) => item.type);
        setLocations(locationTypes);
      } else {
        toast.error("Failed to fetch locations.");
      }

      const res = await AxiosInstance.post(
        `${BaseUrl}/api/v1/files/getImages`,
        { location: "All" },
        {
          params: {
            page: backendPage,
            size: itemsPerPage,
          },
        }
      );

      if (res.data.status === 200) {
        const processedImages = res.data.data.content.map((img) => ({
          id: img.key,
          location: img.location,
          imageUrl: img.file ? `data:image/png;base64,${img.file}` : "",
        }));

        setImages(processedImages);
        setTotalPages(res.data.data.totalPages);
        setTotalItems(res.data.data.totalItems);
        setCurrentPage(pageNumber);
      } else {
        toast.error(res.data.message || "Failed to load images.");
      }
    } catch (error) {
      handleAxiosError(error);
      // toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(isloading());
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setViewImages(images.slice(0, itemsPerPage));
  }, [images]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      fetchData(pageNumber);
    }
    // setCurrentPage(pageNumber);
    // const startIndex = (pageNumber - 1) * itemsPerPage;
    // const endIndex = pageNumber * itemsPerPage;
    // setViewImages(images.slice(startIndex, endIndex));
  };

  const handleNextPage = () => {
    handlePageChange(currentPage + 1);
  };

  const handlePreviousPage = () => {
    handlePageChange(currentPage - 1);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        toast.error(
          "Invalid file type. Please upload an image in jpg, png or jpeg format"
        );
        fileInputRef.current.value = "";
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        toast.error("File size exceeds 2MB.");
        fileInputRef.current.value = "";
        return;
      }
      setNewImage({ ...newImage, file });
    }
  };

  const handleLocationChange = (e) => {
    setNewImage({ ...newImage, location: e.target.value });
  };

  const handleSave = async () => {
    if (!newImage.location || !newImage.file) {
      toast.error("Please fill in the location and upload an image.", {
        closeButton: "false",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", newImage.file);
    formData.append("location", newImage.location);
    dispatch(isloading());
    try {
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/v1/files/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        }
      );

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchData();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error uploading the image.");
    } finally {
      setNewImage({ location: "", file: null });
      if (fileInputRef.current) fileInputRef.current.value = "";
      dispatch(isloading());
    }
  };

  const handleDelete = async (id) => {
    const toastId = toast.warn(
      <div
        style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
      >
        <p>Are you sure you want to delete this image?</p>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-danger btn-sm mx-2"
            onClick={() => confirmDelete(id, toastId)}
          >
            Yes
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,

        // style: { width: "400px", minHeight: "220px" },
        closeButton: false,
      }
    );
  };

  const confirmDelete = async (id, toastId) => {
    toast.dismiss(toastId); // Close the warning toast
    toast.loading("Deleting image...", { position: "top-center" });
    dispatch(isloading());
    try {
      const res = await AxiosInstance.post(
        `${BaseUrl}/api/v1/files/deleteImage`,
        { key: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      toast.dismiss();
      if (res.data.status === 200) {
        toast.success(res.data.message, { position: "top-center" });

        fetchData();
      } else {
        toast.error(res.data.message, { position: "top-center" });
      }
    } catch (error) {
      
      toast.error("Error deleting image.", { position: "top-center" });
    } finally {
      dispatch(isloading());
    }
  };

  useEffect(() => {
    return () => {
      images.forEach((img) => {
        if (img.imageUrl?.startsWith("blob:")) {
          URL.revokeObjectURL(img.imageUrl);
        }
      });
    };
  }, [images]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    // Filter links based on search query (title, location, or link)
    const filteredLinks = images.filter((link) =>
      link.location.toLowerCase().includes(query)
    );

    setTotalItems(filteredLinks.length);
    setCurrentPage(1); // Reset to first page
    setViewImages(filteredLinks.slice(0, itemsPerPage));
  };

  return (
    <div className="home-dashboard">
      <div className="ticket-tab">
        <h3>Upload Image</h3>
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">
              Location<span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <select
              className="form-select"
              value={newImage.location}
              onChange={handleLocationChange}
            >
              <option value="">Select Location</option>
              {locations.map((loc, index) => (
                <option key={index} value={loc}>
                  {loc}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6">
            <label className="form-label">
              Upload Image
              <span style={{ color: "red", fontSize: "1rem" }}>*</span>
            </label>
            <input
              type="file"
              className="form-control"
              ref={fileInputRef}
              onChange={handleFileChange}
            />
          </div>

          <div className="col-md-2 mt-2">
            <button
              type="button"
              className="btn btn-success mt-4"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div className="ticket-tab">
        <div className="row mb-4">
          <div className="col-6">
            <h3>Manage Images</h3>
          </div>

          <div className="col-6">
            <input
              type="text"
              className="form-control"
              placeholder="Search by location.."
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th style={{ width: "30%" }}>Location</th>
                <th>Image</th>
                <th style={{ width: "15%" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {viewImages.length > 0 ? (
                viewImages.map((img) => (
                  <tr key={img.id}>
                    <td>{img.location}</td>
                    <td>
                      {img.imageUrl ? (
                        <img
                          src={img.imageUrl}
                          alt={img.location}
                          width="200"
                          height="100"
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>
                    <td>
                      <FaTrash
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={() => handleDelete(img.id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    No Images Found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="row mt-4" style={{ "--bs-gutter-x": "0rem" }}>
            <div className="col-5">
              {totalItems > 0
                ? `Showing ${startIndex + 1}-${endIndex} of ${totalItems}`
                : "No items to display"}
            </div>
            <div className="col-7 d-flex justify-content-end">
              <div className="d-flex align-items-center">
                <button
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                  }}
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                >
                  <FaAngleLeft />
                </button>

                <div className="mx-3 d-flex">
                  {getPageNumbers(currentPage, totalPages).map(
                    (pageNum, index) =>
                      pageNum === "..." ? (
                        <span key={`ellipsis-${index}`} className="mx-1">
                          ...
                        </span>
                      ) : (
                        <button
                          key={pageNum}
                          className={`btn mx-1 ${
                            currentPage === pageNum
                              ? "active btn-primary"
                              : "btn-light"
                          }`}
                          onClick={() => handlePageChange(pageNum)}
                        >
                          {pageNum}
                        </button>
                      )
                  )}
                </div>

                <button
                  style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                  }}
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  onClick={handleNextPage}
                  disabled={currentPage >= totalPages}
                >
                  <FaAngleRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Images;
